import { ProductCardTag } from '../../product-card.types'

import { TAG_PRIORITY } from './product-tags.constants'

// Function to get tag priority
export const getTagPriority = (tagValue: string): number => {
  const priorityMap: Record<string, number> = {
    [TAG_PRIORITY.SOLD_OUT_TAG]: 1,
    [TAG_PRIORITY.SALE_TAG]: 2,
    [TAG_PRIORITY.EARN_CREDIT_TAG]: 3,
    [TAG_PRIORITY.PRE_ORDER_TAG]: 4,
    [TAG_PRIORITY.PRE_ORDER_TAG_WITH_SPACE]: 5,
    [TAG_PRIORITY.LAST_CHANCE]: 6,
    [TAG_PRIORITY.BUNDLE_TAG]: 7,
    [TAG_PRIORITY.NEW_TAG]: 8,
    [TAG_PRIORITY.BEST_SELLER]: 9,
    [TAG_PRIORITY.LOW_STOCK_TAG]: 10,
    [TAG_PRIORITY.BACK_IN_STOCK_TAG]: 11,
  }

  const lowerTag = tagValue.toLowerCase()
  //Handle dynamic SALE_TAGs for both percent (%) OR dollar ($)
  if (lowerTag.includes('save') && (lowerTag.includes('%') || lowerTag.includes('$'))) {
    return priorityMap[TAG_PRIORITY.SALE_TAG] ?? 999
  }
  if (lowerTag.includes('earn') && lowerTag.includes('$')) {
    return priorityMap[TAG_PRIORITY.EARN_CREDIT_TAG] ?? 999
  }

  return priorityMap[tagValue] ?? 999 // Default to lowest priority if not in the map
}

export const makeProductCardTag = (text: string): ProductCardTag => ({ value: text, displayName: text })
